/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import type { ExecRiskUSAddress } from './ExecRiskUSAddress';
import {
    ExecRiskUSAddressFromJSON,
    ExecRiskUSAddressFromJSONTyped,
    ExecRiskUSAddressToJSON,
} from './ExecRiskUSAddress';

/**
 * 
 * @export
 * @interface ExecRiskIdRelatedTaxExemptOrg
 */
export interface ExecRiskIdRelatedTaxExemptOrg {
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    DisregardedEntityName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {ExecRiskUSAddress}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    USAddress?: ExecRiskUSAddress;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    ForeignAddress?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    EIN?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    PrimaryActivitiesTxt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    LegalDomicileStateCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    LegalDomicileForeignCountryCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    ExemptCodeSectionTxt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    PublicCharityStatusTxt?: string;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    DirectControllingEntityName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    DirectControllingNACd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskIdRelatedTaxExemptOrg
     */
    ControlledOrganizationInd?: string;
}

/**
 * Check if a given object implements the ExecRiskIdRelatedTaxExemptOrg interface.
 */
export function instanceOfExecRiskIdRelatedTaxExemptOrg(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskIdRelatedTaxExemptOrgFromJSON(json: any): ExecRiskIdRelatedTaxExemptOrg {
    return ExecRiskIdRelatedTaxExemptOrgFromJSONTyped(json, false);
}

export function ExecRiskIdRelatedTaxExemptOrgFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskIdRelatedTaxExemptOrg {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'DisregardedEntityName': !exists(json, 'DisregardedEntityName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['DisregardedEntityName']),
        'USAddress': !exists(json, 'USAddress') ? undefined : ExecRiskUSAddressFromJSON(json['USAddress']),
        'ForeignAddress': !exists(json, 'ForeignAddress') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON(json['ForeignAddress']),
        'EIN': !exists(json, 'EIN') ? undefined : json['EIN'],
        'PrimaryActivitiesTxt': !exists(json, 'PrimaryActivitiesTxt') ? undefined : json['PrimaryActivitiesTxt'],
        'LegalDomicileStateCd': !exists(json, 'LegalDomicileStateCd') ? undefined : json['LegalDomicileStateCd'],
        'LegalDomicileForeignCountryCd': !exists(json, 'LegalDomicileForeignCountryCd') ? undefined : json['LegalDomicileForeignCountryCd'],
        'ExemptCodeSectionTxt': !exists(json, 'ExemptCodeSectionTxt') ? undefined : json['ExemptCodeSectionTxt'],
        'PublicCharityStatusTxt': !exists(json, 'PublicCharityStatusTxt') ? undefined : json['PublicCharityStatusTxt'],
        'DirectControllingEntityName': !exists(json, 'DirectControllingEntityName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['DirectControllingEntityName']),
        'DirectControllingNACd': !exists(json, 'DirectControllingNACd') ? undefined : json['DirectControllingNACd'],
        'ControlledOrganizationInd': !exists(json, 'ControlledOrganizationInd') ? undefined : json['ControlledOrganizationInd'],
    };
}

export function ExecRiskIdRelatedTaxExemptOrgToJSON(value?: ExecRiskIdRelatedTaxExemptOrg | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'DisregardedEntityName': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.DisregardedEntityName),
        'USAddress': ExecRiskUSAddressToJSON(value.USAddress),
        'ForeignAddress': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON(value.ForeignAddress),
        'EIN': value.EIN,
        'PrimaryActivitiesTxt': value.PrimaryActivitiesTxt,
        'LegalDomicileStateCd': value.LegalDomicileStateCd,
        'LegalDomicileForeignCountryCd': value.LegalDomicileForeignCountryCd,
        'ExemptCodeSectionTxt': value.ExemptCodeSectionTxt,
        'PublicCharityStatusTxt': value.PublicCharityStatusTxt,
        'DirectControllingEntityName': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.DirectControllingEntityName),
        'DirectControllingNACd': value.DirectControllingNACd,
        'ControlledOrganizationInd': value.ControlledOrganizationInd,
    };
}

